export default {
  ROUND_TRIP: 'letenka tam i zpět',
  ONE_WAY: 'jednosměrná letenka',
  OPEN_JAW: 'letenka s přestupem',
  ACTION_MAP: 'Mapa akčních letenek',
  CURRENCY: 'CZK',
  FROM: 'od'
}



/** WEBPACK FOOTER **
 ** c:/Users/martin.nikl/Desktop/SA GITLAB/frontend/sites/letenky.cz/src/js/offers/langs.js
 **/